import { StateKey } from 'common/utils/flipState'
import { CommonState } from 'common/types'
import { fetchReviewIds as fetchServerPhotoVideoReviewIds } from 'common/services/review'
import { ReviewIdsState } from 'common/types/entities/review'
import { ReviewContentClassType, ReviewIds, ReviewServiceType, ReviewSortType } from 'common/types/entities/api/review'

const FETCH = 'review/photoVideoReviewIds/FETCH'

const initialState: ReviewIdsState = {
  reviewIds: [],
  totalCount: 0,
}

export const fetchPhotoVideoReviewIds = (curState: StateKey, merchantNo: string, originProductNo: string) => async (
  dispatch,
  getState: () => CommonState,
) => {
  const reviewIds: ReviewIds = await fetchServerPhotoVideoReviewIds({
    merchantNo,
    originProductNo,
    reviewContentClassTypes: [ReviewContentClassType.VIDEO, ReviewContentClassType.PHOTO],
    reviewServiceType: ReviewServiceType.SELLBLOG,
    sortType: ReviewSortType.REVIEW_RANKING,
  })

  dispatch({
    curState,
    reviewIds: reviewIds.ids,
    totalCount: reviewIds.totalCount,
    type: FETCH,
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
      return {
        reviewIds: action.reviewIds,
        totalCount: action.totalCount,
      }
    default:
      return state
  }
}

export default reducer
